//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../no/Builder.js";
import "../Features/Features.SelectFeature.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/Features.js";
let d=[[[1,"FeatureToView",0,"Features.SelectFeature",0],[1,"ImpactorToView",0,"ScCollector",0]],[[[],"GetImpactorDataProvider",{R_:{impactorDataProvider:"Features.VehicleDesign.SectionViewDataProvider"}},0,0],[["definitionType"],"UpdateImpactorInformation",{},1,0],[["rowID"],"CreateSection",{},1,0],[["rowID"],"DeleteSection",{},1,0]],[]];
SPLM.Features.VehicleDesign.SectionViewBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.SectionViewBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.SectionViewBuilder.ImpactorDefinitionType = Object.freeze({
    "Feature" : "Feature", "Body" : "Body"});

export default SPLM;